import { useQuery } from '@tanstack/react-query'
import {
	type GetOrganizationImportStatus,
	getOrganizationImportStatus,
} from './actions'

export const useImportStats = (
	organizationId: string,
	initialData?: GetOrganizationImportStatus,
) => {
	return useQuery({
		queryKey: ['organization', organizationId, 'dataImport', 'stats'],
		queryFn: () => getOrganizationImportStatus(organizationId),
		initialData,
		refetchInterval: (query) => {
			return query.state.data?.imports?.length ? 3000 : 30000
		},
	})
}
